import FJConfig from '../config/FJConfig';
import { RELEASE, LOCAL } from '../constants/FJEvnConstant';
import FJUtil from '../util/FJUtil';
import FJRequirementsUtil from '../util/FJRequirementsUtil.js';
import FJTextToVideoStore from './FJTextToVideoStore.js';
import FJConstant from '../constants/FJConstant.js';
import { PAGE_LIMIT } from '../config/dataConfig/FJCommunityData.js';
import FJCommunityUtil from '../util/FJCommunityUtil.js';
const environment = import.meta.env.MODE; // 当前环境

const BASE_URL =
    environment === RELEASE
        ? 'https://www.flexclip.com'
        : environment === LOCAL
          ? window.location.origin
          : 'https://www.smartvideomaker.com';

const RESOURCE_URL = environment === RELEASE ? 'https://resource.flexclip.com/' : 'https://www.smartvideomaker.com/';

const LOCAL_USER_ID = '362';

let f_getBatchTaskInfo = {};

const _isTeamSpace = () => {
    // TODO:团队 移动端暂时使用个人积分
    return FJUtil.isTeamSpace() && !FJUtil.isMobile();
};
const _fetch = async (api, formData, method = 'POST', checkLogin = false) => {
    const url = BASE_URL + api;
    if (FJRequirementsUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

    let headers = {};

    if (FJRequirementsUtil.isLocalhost()) {
        headers.uuid = '876070005@qq.com';
    }
    // else {
    //     const uid = FJUtil.getUserId();
    //     uid && formData.append('uid', uid);
    // }
    const response = await fetch(url, {
        method,
        body: formData,
        headers,
        credentials: environment === LOCAL ? 'include' : 'same-origin',
    });
    const { data, code } = await response.json();
    if (code === 200) {
        return data;
    } else if (code === 214 && checkLogin) {
        FJUtil.login(() => {});
        return null;
    }
    return null;
};
/**
 * @description 接口验证
 * @param formData
 */
const addCSRFToken = formData => {
    if (window.csrf_token) {
        formData.append(window.csrf_token, 1);
    }
};

export default {
    /**
     * 图生图
     * @param {*} data
     * @returns
     */
    imgToImg: async options => {
        const { prompt, image, negativePrompt, conditionScale, seed, numOutputs, style, ratio, privacyStatus } =
            options;
        const url = BASE_URL + '/ai/img-to-img';
        const formData = new FormData();
        formData.append('prompt', prompt);
        formData.append('image', image);
        formData.append('style', style);
        formData.append('num_outputs', numOutputs);
        formData.append('aspect_ratio', ratio);
        formData.append('work_status', privacyStatus);

        negativePrompt && formData.append('negative_prompt', negativePrompt);
        conditionScale && formData.append('condition_scale', conditionScale);
        seed && formData.append('seed', seed);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    imageProcessing: async options => {
        const {
            image,
            colorize,
            enhance,
            repair,
            factor,
            scratch_repair_mask,
            scratch_repair,
            original_image,
            generate_mask,
        } = options;
        // const { image, colorize, enhance, repair, factor, modelType } = options;
        const url = BASE_URL + '/ai/image-processing';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('colorize', colorize);
        formData.append('enhance', enhance);
        formData.append('repair', repair);
        enhance && formData.append('factor', factor);
        scratch_repair_mask && formData.append('scratch_repair_mask', scratch_repair_mask);
        scratch_repair && formData.append('scratch_repair', scratch_repair);
        original_image && formData.append('original_image', original_image);
        generate_mask && formData.append('generate_mask', generate_mask);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        // enhance && formData.append('model_type', modelType);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 三合一图像处理 新
     * @param {*} options
     * @returns
     */
    imageManipulation: async options => {
        const { image, prompt, enhance, factor, originalImage, colorize } = options;
        const url = BASE_URL + '/v1/ai/image-manipulation';

        const formData = new FormData();
        formData.append('image', image);
        formData.append('prompt', prompt);
        formData.append('enhance', enhance ? 1 : 0);
        formData.append('factor', factor);
        formData.append('original_image', originalImage);
        colorize && formData.append('colorize', colorize);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 生成 自动划痕检测 mask 图
     * @param {*} options
     * @returns
     */
    generateScratchRepairMask: async options => {
        const { imageUrl } = options;
        const url = BASE_URL + '/ai/generate-scratch-repair-mask';
        const formData = new FormData();
        formData.append('image', imageUrl);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();

        if (code === 200) {
            return data.mask;
        }
        return null;
    },

    imageEnhancer: async options => {
        const { image, factor } = options;
        const url = BASE_URL + '/ai/image-enhancer-task';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('factor', factor);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 换装
     * @param {Object} options
     * @param {string} options.image
     * @param {string} options.garment
     * @param {'doubao','fal'} options.model_type
     * @returns
     */
    clothesChanger: async options => {
        const { image, garment, model_type } = options;
        const url = BASE_URL + '/ai/create-clothes-changer-task';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('garment', garment);
        formData.append('model_type', model_type);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    /**
     * @description 换发
     * @param {Object} options
     * @param {string} options.input_image input_image
     * @param {string} options.haircut haircut
     * @param {string} options.hair_color hair_color
     * @param {string} options.gender gender
     */
    hairstyleChanger: async options => {
        const { input_image, haircut, hair_color, gender } = options;
        const url = BASE_URL + '/v1/ai/hairstyle-changer';
        const formData = new FormData();
        formData.append('input_image', input_image);
        formData.append('haircut', haircut);
        formData.append('hair_color', hair_color);
        formData.append('gender', gender);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
            credentials: FJRequirementsUtil.isLocalhost() ? 'include' : 'same-origin',
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * 获取任务状态
     * @param {} eventId
     * @returns
     */
    getNewTaskState: async eventId => {
        const api = '/v1/ai/get-state';
        const formData = new FormData();
        formData.append('event_id', eventId);
        try {
            return await _fetch(api, formData);
        } catch (error) {
            return;
        }
    },

    /**
     * 获取任务状态
     * @param {} eventId
     * @returns
     */
    getTaskState: async eventId => {
        const api = '/rp/get-state';
        const formData = new FormData();
        formData.append('event_id', eventId);
        try {
            return await _fetch(api, formData);
        } catch (error) {
            return;
        }
    },

    /**
     * 获取doubao任务状态
     * @param {object} options
     * @param {string} options.type
     * @returns
     */
    getDoubaoTaskState: async options => {
        const api = '/v1/ai/db-result';
        const formData = new FormData();
        formData.append('type', options.type);
        try {
            return await _fetch(api, formData);
        } catch (error) {
            return;
        }
    },

    /**
     * 获取任务状态
     * @param {} eventId
     * @returns
     */
    cancelTask: async eventId => {
        const api = '/rp/cancel';
        const formData = new FormData();
        formData.append('event_id', eventId);
        return await _fetch(api, formData);
    },
    /**
     * 获取默认免费使用次数
     * @returns
     */
    getUseDefaultFreeLimit: async () => {
        const url = '/v1/ai/get-limit';
        const res = await fetch(url, { method: 'GET' });
        const { code, data } = await res.json();
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    },
    /**
     * 获取免费使用次数
     * @returns
     */
    getUseFreeLimit: async () => {
        const api = '/ai/get-use-free-limit';
        const formData = new FormData();
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        return await _fetch(api, formData);
    },
    /**
     * 获取图片列表
     * @param {*} eventType 3：图生图 4:图像处理
     * @returns
     */
    getTaskList: async (eventType = '3') => {
        const api = '/ai/task-list';
        const formData = new FormData();
        formData.append('event_type', eventType);
        return await _fetch(api, formData);
    },
    deleteTaskList: async ids => {
        const url = BASE_URL + '/rp/delete';
        const formData = new FormData();
        formData.append('ids', ids);
        if (FJRequirementsUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await response.json();
        return { data, code };
    },
    /**
     * @description 返回积分额度
     * @returns {Promise<{[p: string]: *}>}
     */
    async getCreditsInfo() {
        let url = BASE_URL + '/user/get-credit-info';
        if (_isTeamSpace()) url += `?tid=${FJUtil.getCurrentSpaceId()}`;

        const res = await fetch(url, { method: 'GET' });
        const { code, data } = await res.json();
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    },
    async checkIsLogin() {
        const url = BASE_URL + '/user/checkState';
        const res = await fetch(url, {
            method: 'GET',
        });
        const { data, code } = await res.json();
        return data?.result && code == 200;
    },
    async getSpaceData() {
        const url = BASE_URL + '/user/get-space-data';
        const res = await fetch(url, {
            method: 'GET',
        });
        const { code, data } = await res.json();
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    },

    /**
     * @description 文本生成图片
     * @param {Object} param
     * @param {string} param.prompt
     * @param {string} param.model_type
     * @param {string} param.ratio
     * @param {number} param.generateNumber
     * @param {string} param.style
     * @param {string} param.prompt_val
     * @param {string} param.input_prompt
     * @param {string} param.inputImage
     * @param {string} param.size
     * @param {string} param.privacyStatus
     * @returns {Promise<any>}
     */
    async textToImage(param) {
        const url = BASE_URL + '/v1/ai/text-to-image';
        const formData = new FormData();
        formData.append('prompt', param.prompt);
        formData.append('model', param.model_type);
        param.ratio && formData.append('aspect_ratio', param.ratio === 'auto' ? '' : param.ratio);
        formData.append('num_outputs', param.generateNumber);
        formData.append('style', param.style);
        formData.append('prompt_val', param.prompt_val);
        formData.append('input_prompt', param.input_prompt);

        formData.append('work_status', param.privacyStatus);
        // param.inputImage && formData.append('input_image', param.inputImage);
        // param.inputImages && formData.append('input_images', param.inputImages);
        const images = param.inputImages ? param.inputImages.join() : param.inputImage;
        formData.append('input_images', images);
        param.size && formData.append('size', param.size);
        if (FJUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async batchTextToImage(param) {
        const url = BASE_URL + '/ai/batch-text-to-image';
        const formData = new FormData();
        formData.append('prompts', param.prompts);
        formData.append('model_type', param.model_type);
        formData.append('aspect_ratio', param.ratio);
        formData.append('num_outputs', param.generateNumber);
        formData.append('style', param.style);
        formData.append('prompt_val', param.prompt_val);
        formData.append('input_prompt', param.input_prompt);
        if (FJUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 翻译value
     * @param {JSON} value
     * @param toLanguage
     * @returns {Promise<any>}
     */
    async translateValueToLanguage(value, toLanguage = 'en') {
        // 使用我们的接口
        const formData = new FormData();
        formData.append('data', JSON.stringify(value));
        formData.append('to_language', toLanguage);
        if (FJUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        const response = await fetch(BASE_URL + '/ai/translate-text', {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200) {
            const list = JSON.parse(data);
            return list;
        }
    },

    /**
     * @description 生成图片描述
     * @param {String} fileUrl
     * @param {String} currentLang
     * @returns {Promise<any>}
     */
    async generateImageByPrompt(fileUrl, currentLang = 'en') {
        const url = BASE_URL + '/ai/generate-image-desc';
        const formData = new FormData();
        formData.append('image', fileUrl);
        formData.append('current_lang', currentLang);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 生成图片描述 - 视频配音接口用
     * @param {String} fileUrl
     * @param {String} currentLang
     * @returns {Promise<any>}
     */
    async generateImageByPromptInAiSfx(fileUrl, currentLang = 'en') {
        const url = BASE_URL + '/v1/ai/generate-image-desc';
        const formData = new FormData();
        formData.append('image', fileUrl);
        formData.append('current_lang', currentLang);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI提示词优化
     * @returns
     */
    async aiOptimizing(prompt) {
        const url = BASE_URL + '/ai/optimization-description';

        const urlWithParams = `${url}?prompt=${prompt}`;

        const res = await fetch(urlWithParams, {
            method: 'GET',
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI图片扩展
     * @returns
     */
    async imageExtender(imageUrl, left, right, top, bottom, scale) {
        const url = BASE_URL + '/ai/create-image-extender-task';
        const formData = new FormData();
        formData.append('image', imageUrl);
        formData.append('left', left);
        formData.append('right', right);
        formData.append('top', top);
        formData.append('bottom', bottom);
        formData.append('scale', scale);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI换脸
     * @returns
     */
    async faceSwap(originImageUrl, targetImageUrl) {
        const url = BASE_URL + '/ai/create-face-swap-task';
        const formData = new FormData();
        formData.append('face_swap_target', originImageUrl);
        formData.append('image', targetImageUrl);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 生成深度图
     * @param {String} fileUrl
     * @param {String} currentLang
     * @returns {Promise<any>}
     */
    async generateDepthMap(fileUrl) {
        const url = BASE_URL + '/ai/depth-map';
        const formData = new FormData();
        formData.append('image', fileUrl);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async updateDepthMapInfo(evenId, info) {
        const url = BASE_URL + '/ai/update-depth-map-info';
        const formData = new FormData();
        formData.append('event_id', evenId);
        formData.append('info', info);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 获取AI mask
     * @returns
     */
    async getAiMask(imageUrl) {
        const url = BASE_URL + '/ai/analyze-image-generate-mask';

        const formData = new FormData();
        formData.append('image', imageUrl);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();

        if (code === 200) {
            return data && data.json;
        }
        return null;
    },

    /**
     * @desc 物体擦除
     * @returns
     */
    async objectEraserTask(options) {
        const url = BASE_URL + '/ai/object-erasure-task';

        const { image, mask, original_image, prompt } = options;
        const formData = new FormData();
        formData.append('image', image);
        formData.append('mask', mask);
        original_image && formData.append('original_image', original_image);
        prompt && formData.append('prompt', prompt);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 文本物体抹除
     * @returns
     */
    async textObjectEraseTask(options) {
        const url = BASE_URL + '/v1/ai/prompt-removal';

        const { image, prompt, originalPrompt } = options;
        const formData = new FormData();
        formData.append('input_image', image);
        prompt && formData.append('prompt', prompt);
        originalPrompt && formData.append('original_prompt', originalPrompt);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 手动去创建背景擦除历史
     * @returns
     */
    async createRemoveBackgroundHistory(options) {
        const url = BASE_URL + '/ai/create-remove-background-history';
        const formData = new FormData();
        formData.append('filename', options.filename);
        formData.append('original', options.original);
        formData.append('info', JSON.stringify(options.info));
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 自动去背景
     * @returns
     */
    async autoBackgroundRemove(options) {
        const url = BASE_URL + '/ai/auto-background-remove';
        const formData = new FormData();
        formData.append('image', options.image);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            const { data, code } = await res.json();
            return { data, code };
        } catch (error) {
            return { data: null, code: 500 };
        }
    },

    /**
     * @desc AI生成视频
     * @returns
     */
    async videoGeneration(options) {
        const url = BASE_URL + '/ai/create-video-generation-task';
        const {
            imageUrl,
            generationType,
            modelType,
            prompt,
            duration,
            ratio,
            waterfallRatio,
            source,
            audioActive,
            audioPrompt,
        } = options;
        const formData = new FormData();
        formData.append('generation_type', generationType);
        formData.append('model_type', modelType);
        formData.append('image_url', imageUrl);
        prompt && formData.append('prompt', prompt);
        formData.append('duration', duration);
        formData.append('aspect_ratio', ratio);
        formData.append('waterfall_ratio', waterfallRatio);
        formData.append('source', source);
        formData.append('is_dubbing', audioActive ? 1 : 0);
        audioPrompt && formData.append('audio_prompt', audioPrompt);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI生成视频V2 使用新模型和新的参数schema
     * @returns
     */
    async videoGenerationV2(options) {
        const url = BASE_URL + '/v1/ai/video-generation';
        const formData = new FormData();

        const params = {
            prompt: options.prompt,
            duration: options.duration,
            ratio: options.ratio,
            images: options.images,
            is_dubbing: options.audioActive ? 1 : 0,
            audio_prompt: options.audioPrompt,
            waterfall_ratio: options.waterfallRatio,
            source: options.source,
            current_image_mode: options.currentImageMode,
            resolution: options.resolution,
            orientation: options.orientation,
            videos: options.videos,
        };
        formData.append('params', JSON.stringify(params));
        formData.append('generation_type', options.generationType);
        formData.append('model_type', options.modelType);
        formData.append('work_status', options.privacyStatus);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 视频去背景添加预测点
     * @returns
     */
    async videoRemoveBackgroundAddPoints(currentTime, objectId, points, base64String) {
        try {
            const normalizedPoints = points.map(p => [p[0], p[1]]);
            const labels = points.map(() => 1);

            const res = await fetch(BASE_URL + '/ai/add-points', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    session_id: '0',
                    frame_index: 0,
                    object_id: objectId,
                    labels,
                    points: normalizedPoints,
                    clear_old_points: true,
                    start_time: currentTime,
                    image_base64: base64String,
                }),
            });

            const data = await res.json();
            return data;
        } catch (err) {
            return null;
        }
    },

    /**
     * @desc 自动视频去背景
     * @returns
     */
    async autoVideoRemoveBackground(options) {
        let fetchUrl = BASE_URL + '/ai/auto-rm-video-bg';

        if (_isTeamSpace()) {
            fetchUrl += `?tid=${FJUtil.getCurrentSpaceId()}`;
        }

        const res = await fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(options),
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 视频去背景跟踪
     * @returns
     */
    async videoRemoveBackgroundTrack(options) {
        let fetchUrl = BASE_URL + '/ai/manually-rm-video-bg';

        if (_isTeamSpace()) {
            fetchUrl += `?tid=${FJUtil.getCurrentSpaceId()}`;
        }

        const res = await fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(options),
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    async audioM2MGeneration(options) {
        const url = BASE_URL + '/ai/generate-music-task';
        const { audioUrl, voiceUrl, incidentalUrl, lyrics, info } = options;
        const formData = new FormData();
        audioUrl && formData.append('song_file', audioUrl);
        voiceUrl && formData.append('voice_file', voiceUrl);
        incidentalUrl && formData.append('instrumental_file', incidentalUrl);
        lyrics && formData.append('lyrics', lyrics);
        formData.append('info', JSON.stringify(info));
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async audioT2MGeneration(options) {
        const url = BASE_URL + '/ai/text-to-music';
        const { prompt, type, lyrics, duration, tagStyle: tag_style, originPrompt: origin_prompt } = options;
        const formData = new FormData();
        prompt && formData.append('prompt', prompt);
        type && formData.append('gen_scene', type);
        duration && formData.append('audio_duration', duration);
        lyrics && formData.append('lyrics', lyrics);
        tag_style && formData.append('tag_style', tag_style);
        origin_prompt && formData.append('origin_prompt', origin_prompt);

        if (FJRequirementsUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async soundEffectGeneration(options) {
        const url = BASE_URL + '/ai/generate-effect';
        const { prompt, isEnglish } = options;
        const formData = new FormData();
        formData.append('prompt', prompt);
        formData.append('need_translation', isEnglish ? 0 : 1);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async generateLyric(options) {
        const url = BASE_URL + '/ai/generate-lyrics';
        const { content, currentLang } = options;
        const formData = new FormData();
        formData.append('content', content);
        currentLang && formData.append('current_lang', currentLang);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async updateEventInfo(options) {
        const url = BASE_URL + '/ai/update-event-info';
        const { eventId, info } = options;
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('info', JSON.stringify(info));

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async regenerateCoverImage(options) {
        const url = BASE_URL + '/ai/regenerate-cover-image';
        const { videoUrl, eventId } = options;
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('url', videoUrl);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 返回语音服务token
     * @returns {Promise<*>}
     */
    async getVoiceServiceToken() {
        const url = BASE_URL + '/ai/get-audio-token';
        const formData = new FormData();
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        addCSRFToken(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data } = await res.json();
        const { token } = data;
        return token;
    },
    async getVoiceList(token) {
        const url = 'https://eastus.tts.speech.microsoft.com/cognitiveservices/voices/list';
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                authorization: 'Bearer: ' + token,
            },
        });
        const voiceList = await res.json();
        return voiceList;
    },
    async getTextToSpeechVoices() {
        const url = `${RESOURCE_URL}json/ai/text-to-speech-voices.json?v=${FJConfig.textToSpeechVoicesVersion}`;
        const voiceRes = await fetch(url, {
            method: 'GET',
        });
        const voiceList = await voiceRes.json();
        return voiceList;
    },
    /**
     * @desc 抓取页面/商品数据
     * @param {*} url
     * @returns
     */
    async spiderPageByURL(options) {
        const { type, url } = options;
        const formData = new FormData();
        formData.append('url', url);
        formData.append('type', type);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        const response = await fetch(BASE_URL + '/ai/spider-page', {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200) {
            return JSON.parse(data);
        }
        return null;
    },
    /**
     * @desc 抓取页面数据 1:生成脚本 2：分割脚本 3：生成AI图片提示词 4：生成关键字 5: 文章分析 6: 产品分析 7: ppt分析
     * @param {*} url
     * @returns
     */
    async getChatData(options) {
        const { stream = 0, type, prompt, language } = options;
        const formData = new FormData();
        formData.append('stream', stream);
        formData.append('type', type);
        formData.append('prompt', prompt);
        if (language) {
            formData.append('lang', language);
        }
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        let url = BASE_URL + '/ai/get-chat-data';
        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200) {
            return data;
        } else if (code === 401) {
            FJUtil.getCredits(FJTextToVideoStore.getAppType());
            return null;
        }
        return null;
    },
    /**
     * @desc 批量生成谷歌图片
     * @param {*} url
     * @returns
     */
    async geminiGenerateImage(options) {
        const { style, prompt, ratio } = options;
        const formData = new FormData();
        formData.append('style', style);
        formData.append('prompt', prompt);
        formData.append('ratio', ratio);
        formData.append('type', 8);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        let url = BASE_URL + '/ai/gemini-generate-image';
        if (window.vvv === true) url += '?vv=1';
        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const resData = await response.json();
        if (resData.code === 200) {
            return resData.data;
        }
        return null;
    },
    /**
     * @desc 检测语言
     * @param text
     * @returns {Promise<void>}
     */
    async getLanguageInfoByText(text) {
        const formData = new FormData();
        formData.append('data', text);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        const response = await fetch(BASE_URL + '/ai/detect-language', {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200) {
            return JSON.parse(data);
        }
    },
    /**
     * @description 创建工程
     * @param ratio
     * @param projectName
     */
    async createNewProject(ratio, projectName) {
        let url = '/project/new';
        let ratioType = '';
        switch (FJUtil.toFixed(ratio, 2)) {
            case 1.78:
                ratioType = 'landscape';
                break;
            case 0.56:
                ratioType = 'vertical';
                break;
            case 1:
                ratioType = 'square';
                break;
            case 2.33:
                ratioType = 'cinematic';
                break;
            case 0.8:
                ratioType = 'social';
                break;
            default:
                ratioType = 'landscape';
                break;
        }
        const formData = new FormData();
        formData.append('ratio', ratioType);
        formData.append('project_type', 'simple-timeline');
        if (FJUtil.isTeamSpace()) {
            formData.append('t_id', FJUtil.getCurrentSpaceId());
            url = '/teams/create-project';
        }
        if (projectName) {
            formData.append('name', projectName);
        }
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('page_user_id', LOCAL_USER_ID);
        } else {
            formData.append('page_user_id', FJUtil.getUserId());
        }

        const res = await fetch(BASE_URL + url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        });
        const json = await res.json();

        const { code } = json;

        if (code === 341 || code === 217) {
            // throw new Error('project limit');
            return null;
        } else if (code === 214 || code === 335 || code === 336) {
            // FJUtil.checkLogin(code);
            // throw new Error('login error');
            return null;
        } else {
            return json.data.key;
        }
    },

    /**
     * @desc 批量生成谷歌图片
     * @param {*} url
     * @returns
     */
    async productCrawler(url) {
        const formData = new FormData();
        formData.append('url', url);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }

        const response = await fetch(BASE_URL + '/ai/product-crawler', {
            method: 'POST',
            body: formData,
        });

        const resData = await response.json();
        if (resData.code === 200) {
            return resData.data;
        }
        return null;
    },
    /**
     * @desc ppt 转视频
     * @param {*} url
     * @returns
     */
    async pptToVideo(url) {
        const formData = new FormData();
        formData.append('url', url);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }

        const response = await fetch(BASE_URL + '/ai/doc-to-video', {
            method: 'POST',
            body: formData,
        });

        const resData = await response.json();
        if (resData.code === 200) {
            return resData.data;
        }
        return null;
    },
    // 积分付费
    async payCredit(credit, type) {
        const formData = new FormData();
        formData.append('credit', credit);
        formData.append('name', type);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        const url = `${BASE_URL}/user/deduct-credit`;

        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData,
            });
            const { code } = await res.json();
            if (code === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    },
    async getLimitedTimeCouponInfo(startLimitedTime = true) {
        const url = BASE_URL + '/user/get-limited-time-coupon';

        const formData = new FormData();
        formData.append('enable', startLimitedTime ? 1 : 0);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        try {
            const { data, code } = await res.json();

            if (code === 200) {
                return data;
            }

            return null;
        } catch (error) {
            return null;
        }
    },

    /**
     * @desc 创建视频配音任务
     * @returns
     */
    async createVideoDubTask(options) {
        const fetchUrl = BASE_URL + '/ai/video-to-sound-effect';

        const { url, prompt, duration, width, height, removeOriginAudio, resource, inputPrompt } = options;
        const formData = new FormData();
        formData.append('prompt', prompt);
        formData.append('duration', duration);
        formData.append('url', url);
        formData.append('width', width);
        formData.append('height', height);
        formData.append('save_original_audio', removeOriginAudio ? 0 : 1);
        formData.append('resource', resource);
        formData.append('input_prompt', inputPrompt);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        try {
            const res = await fetch(fetchUrl, {
                method: 'POST',
                body: formData,
            });

            const { data, code } = await res.json();

            return { data, code };
        } catch (error) {
            return null;
        }
    },
    async audioConvertText(audioUrl, language, duration) {
        const api = '/ai/audio-to-word';
        const formData = new FormData();
        formData.append('audio', audioUrl);
        formData.append('lang', language);
        formData.append('duration', duration);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(api, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async getAIClippingContent(data) {
        const api = '/ai/clipping-content';
        const formData = new FormData();
        formData.append('content', data);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        return await _fetch(api, formData);
    },

    /**
     * @description 声音克隆
     * @param options
     * @returns {Promise<{code: *, data: *}>}
     */
    async voiceClone(options) {
        const url = BASE_URL + '/ai/clone-sound';
        const { audioUrl, selectLang, name, avatar } = options;
        const formData = new FormData();
        formData.append('reference_audio', audioUrl);
        formData.append('select_lang', selectLang);
        formData.append('name', name);
        formData.append('avatar', avatar);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    getDataByJson: async function (url) {
        const response = await fetch(url, {
            method: 'GET',
        });
        return await response.json();
    },

    /**
     * @description  获取用户声音收藏
     * @returns {Promise<*|null>}
     */
    getFavoriteVoiceList: async function () {
        const url = FJConfig.requestPath + '/ai/get-sound-collection';
        const formData = new FormData();

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        try {
            const { data, code } = await res.json();
            if (code === 200) {
                return data;
            }
            return null;
        } catch (error) {
            return null;
        }
    },

    /**
     * @description 声音收藏
     * @param id
     * @returns {Promise<{code: *, data: *}>}
     */
    async soundCollection(id) {
        const url = BASE_URL + '/ai/sound-collection';
        const formData = new FormData();
        formData.append('sound_id', id);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 创建TTV工程
     * @param {*} options
     * @returns
     */
    async createTTVProject(options = {}) {
        const url = BASE_URL + '/ai/save-text-to-audio-project';
        const { projectId, text } = options;
        const formData = new FormData();
        projectId && formData.append('project_id', projectId);
        formData.append('text', text);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async deleteTTVProject(ids) {
        const url = BASE_URL + '/ai/delete-text-to-audio-project';
        const formData = new FormData();
        formData.append('project_id', ids);
        if (FJRequirementsUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await response.json();
        return { data, code };
    },

    /**
     * @description 获取TTV工程列表
     * @returns
     */
    async getTTVProjectList() {
        const url = BASE_URL + '/ai/get-text-to-audio-project-list';

        const formData = new FormData();

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 文字转语音
     * @param options
     * @returns {Promise<{code: *, data: *}>}
     */
    async textToAudio(options) {
        const url = BASE_URL + '/ai/text-to-audio';
        const { text, audioUrl, audioText } = options;
        const formData = new FormData();
        formData.append('text', text);
        formData.append('reference_audio', audioUrl);
        formData.append('reference_text', audioText);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 将text中的数字，数学符号替换成对应语言
     * @param text
     * @returns {Promise<{code: *, data: *}>}
     */
    async getTextPrompt(text) {
        const url = BASE_URL + '/ai/get-text-prompt';
        const formData = new FormData();
        formData.append('text', text);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 创建批量合成任务
     * @param list
     * @returns
     */
    async createBatchSynthesis(list) {
        const formData = new FormData();

        formData.append('lists', JSON.stringify(list));

        if (FJRequirementsUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const response = await fetch(BASE_URL + '/ai/more-text-to-audio', {
            method: 'POST',
            body: formData,
        });

        const resData = await response.json();
        if (resData.code === 200) {
            f_getBatchTaskInfo = {
                id: resData?.data?.id,
                isInterrupt: false,
            };
            setTimeout(() => {
                f_getBatchTaskInfo = {
                    id: resData?.data?.id,
                    isInterrupt: true,
                };
            }, 1000 * 60);
            return resData.data;
        } else {
            return resData;
        }
    },

    /**
     * @desc 获取批量合成任务结果
     * @param {*} id
     * @param {*} successCallback
     * @param {*} errorCallback
     */
    async getBatchSynthesis(id, successCallback, errorCallback) {
        const formData = new FormData();
        formData.append('id', id);

        if (FJRequirementsUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }

        const response = await fetch(BASE_URL + '/ai/get-bulk-text-to-audio', {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200 && data.status === 'Succeeded') {
            successCallback(data);
        } else if (code === 200 && (data.status === 'Running' || data.status === 'NotStarted')) {
            if (f_getBatchTaskInfo.id === id && f_getBatchTaskInfo.isInterrupt && data.status === 'NotStarted') {
                errorCallback && errorCallback('getBatchSynthesis timeout', true);
            } else {
                setTimeout(() => {
                    this.getBatchSynthesis(id, successCallback, errorCallback);
                }, 1000);
            }
        } else {
            errorCallback && errorCallback(data, true);
        }
    },

    /**
     * 取消批量合成语音
     */
    interruptGetBatchSynthesis() {
        f_getBatchTaskInfo && (f_getBatchTaskInfo.isInterrupt = true);
    },

    /**
     * @desc 删除批量合成任务
     * @param {*} id
     */
    deleteBatchSynthesis(id) {
        const formData = new FormData();
        formData.append('id', id);

        fetch(BASE_URL + '/ai/delete-bulk-text-to-audio', {
            method: 'POST',
            body: formData,
        });
    },

    /**
     * @desc 下载文件链接转为blob
     * @param {*} fileUrl
     * @param {*} callback
     * @param {*} onerror
     */
    urlToBlob(fileUrl) {
        return new Promise(res => {
            try {
                const url = BASE_URL + '/ai/get-text-to-audio-result';
                let xhr = new XMLHttpRequest();
                xhr.open('POST', url, true);
                xhr.responseType = 'blob';
                const formData = new FormData();
                if (FJRequirementsUtil.isLocalhost()) {
                    formData.append('uid', LOCAL_USER_ID);
                }
                formData.append('url', fileUrl);
                xhr.onload = function () {
                    if (this.status == 200) {
                        res(this.response);
                    } else {
                        res();
                    }
                };
                xhr.onerror = () => {
                    res();
                };
                xhr.send(formData);
            } catch (e) {
                res();
            }
        });
    },

    /**
     * @description 特效视频生成（图生图+提示词 生成视频特效）
     * @param type
     * @param options
     * @returns {Promise<{data: *, code: *}>}
     */
    async videoEffectGeneration(type, options) {
        let url;
        const formData = new FormData();
        switch (type) {
            case FJConstant.IMG2IMG_KLING16_PROMPT: {
                url = BASE_URL + '/ai/gen-video-effect-cm';
                const { imageUrl, styleId, prompt, ratio, privacyStatus } = options;
                formData.append('kl_prompt', prompt);
                formData.append('image_url', imageUrl);
                formData.append('style', styleId);
                // formData.append('duration', duration);
                formData.append('aspect_ratio', ratio);
                formData.append('work_status', privacyStatus);
                break;
            }
            case FJConstant.KLING16_EFFECT_STD:
            case FJConstant.WAN_EFFECTS: {
                url = BASE_URL + '/ai/gen-video-effect-am';
                const { imageUrl, videoUrl, styleId, prompt, ratio, privacyStatus } = options;
                formData.append('prompt', prompt);
                formData.append('input_image_urls', imageUrl);
                formData.append('input_video_urls', videoUrl);
                formData.append('effect_scene', styleId);
                formData.append('aspect_ratio', ratio);
                formData.append('work_status', privacyStatus);
                break;
            }
            case FJConstant.KLING16: {
                url = BASE_URL + '/ai/gen-video-effect-bm';
                const { imageUrl, prompt, styleId, ratio, privacyStatus } = options;
                formData.append('prompt', prompt);
                formData.append('input_image_urls', imageUrl);
                formData.append('effect_scene', styleId);
                formData.append('aspect_ratio', ratio);
                formData.append('work_status', privacyStatus);
                break;
            }
            default:
        }

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 水印去除 （图片水印去除）
     * @param options
     * @returns {Promise<{data: *, code: *}>}
     */
    async watermarkRemover(options) {
        const url = BASE_URL + '/v1/ai/watermark-remover';
        const { imageUrl } = options;
        const formData = new FormData();
        formData.append('input_image', imageUrl);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    /**
     * @description 文本物体抹除优化翻译prompt
     * @param prompt
     * @returns {Promise<{data: *, code: *}>}
     */
    async optimizeTranslatePrompt(options) {
        const url = BASE_URL + '/v1/ai/optimization-description';
        const { prompt, currentLang, type = 'prompt_removal' } = options;

        const formData = new FormData();
        formData.append('prompt', prompt);
        formData.append('current_lang', currentLang);
        formData.append('type', type);

        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            const { data, code } = await res.json();

            if (code === 200) {
                return data.prompt;
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    },

    /**
     * @description 图片编辑器
     * @param {{
     *  prompt: string;
     *  originalPrompt: string;
     *  inputImage: string;
     *  waterfallRatio: number;
     *  inputImages: string[];
     *  model: string;
     * }} options
     * @returns {Promise<{data: *, code: *}>}
     */
    async aiPhotoEditor(options) {
        const url = BASE_URL + '/v1/ai/photo-editor';
        const {
            prompt,
            originalPrompt,
            inputImage,
            waterfallRatio,
            inputImages,
            model,
            ratio = '',
            resolution = '',
            privacyStatus,
        } = options;
        const formData = new FormData();
        formData.append('prompt', prompt);
        formData.append('original_prompt', originalPrompt);
        // formData.append('input_image', inputImage);
        formData.append('waterfall_ratio', waterfallRatio);
        formData.append('model', model);
        formData.append('aspect_ratio', ratio === 'auto' ? '' : ratio);
        formData.append('resolution', resolution);
        const images = inputImages ? inputImages.join(',') : inputImage;
        formData.append('input_images', images);

        formData.append('work_status', privacyStatus);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 图片编辑器
     * @param {{
     *  img_url: string;
     *  prompt: object[];
     *  height: number;
     *  width: number;
     *  name: string;
     *  category: string;
     * }} options
     * @returns {Promise<{data: *, code: *}>}
     */
    async aiGenerateAvator(options) {
        const url = BASE_URL + '/v1/ai/avatar-generation';
        const { img_url, prompt, height, width, name, category } = options;
        const formData = new FormData();
        formData.append('img_url', img_url);
        formData.append('prompt', JSON.stringify(prompt));
        formData.append('height', height);
        formData.append('width', width);
        formData.append('name', name);
        formData.append('category', category);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description AI图像识别
     * @param {{
     *  imageUrl: string;
     * }} options
     * @returns {Promise<{data: boolean, code: *}>}
     */
    async aiImageRecognition(options) {
        const url = BASE_URL + '/v1/ai/image-validate';
        const { imageUrl, type } = options;
        const formData = new FormData();
        formData.append('image_url', imageUrl);
        type && formData.append('type', type);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 图片编辑器
     * @param {{
     *  id: number,
     *  event_id: string,
     *  img_url: string;
     *  prompt: object;
     *  height: number;
     *  width: number;
     * }} options
     * @returns {Promise<{data: *, code: *}>}
     */
    async aiRetryGenerateAvator(options) {
        const url = BASE_URL + '/v1/ai/avatar-generation-retry';
        const { id, event_id, img_url, prompt, height, width } = options;
        const formData = new FormData();
        formData.append('id', id);
        formData.append('event_id', event_id);
        formData.append('img_url', img_url);
        formData.append('prompt', JSON.stringify(prompt));
        formData.append('height', height);
        formData.append('width', width);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 创建云转码任务
     * @param {string} transcodeFilePath
     * @returns
     */
    async createTranscodeTask(transcodeFilePath) {
        const api = BASE_URL + '/ai/cloud-transcoding';
        const formData = new FormData();
        transcodeFilePath && formData.append('url', transcodeFilePath);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        formData.append('page_user_id', FJUtil.getUserId());
        const res = await fetch(api, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async delCloudTranscodeTask(ids) {
        const api = BASE_URL + '/rp/cancel';
        const formData = new FormData();
        formData.append('event_id', ids.join(','));
        const res = await fetch(api, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    async getTaskIdStateList(mediaIds) {
        const api = BASE_URL + '/ai/check-cloud-transcoding';
        const formData = new FormData();
        formData.append('resources', mediaIds);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(api, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    async checkCloudTranscodeIsExist(mediaIds) {
        const api = BASE_URL + '/ai/check-cloud-transcoding-complete';
        const formData = new FormData();
        formData.append('resources', mediaIds);
        const res = await fetch(api, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 获取工具积分限制信息, 公共接口
     * @param {'text-to-image' | 'photo-editor' | 'img-to-img' | 'text-to-video' | 'image-to-video' | undefined} aiToolName
     * @returns {Promise<{data: *, code: *}>}
     */
    async getToolsCreditLimitInfo(aiToolName) {
        const api = BASE_URL + '/v1/ai/get-tools-credit-limit';
        const params = new URLSearchParams();
        aiToolName && params.append('name', aiToolName);
        const res = await fetch(`${api}?${params.toString()}`, {
            method: 'GET',
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    async getCommunityTypes() {
        const api = BASE_URL + '/v1/community/get-types';
        const res = await fetch(api, {
            method: 'GET',
            credentials: FJRequirementsUtil.isLocalhost() ? 'include' : 'same-origin',
        });
        const { data, code } = await res.json();
        if (code === 200) {
            return data;
        }
        return null;
    },
    async getCommunityList(options = {}) {
        const { start = 0, limit = PAGE_LIMIT, type = '', category = '', userKey = '', sortType = '' } = options;

        const api = '/v1/community/get-list';
        const formData = new FormData();
        formData.append('work_start', start);
        formData.append('limit', limit);
        formData.append('type', type);
        formData.append('category', category);
        formData.append('user_key', userKey);
        formData.append('sort', sortType);
        return await _fetch(api, formData, 'POST');
    },
    async getAICollectionList(eventType) {
        const url = `${BASE_URL}/v1/ai/get-ai-tasks?type=${encodeURIComponent(eventType)}&limit=${20}`;
        let headers = {};
        // if (FJUtil.isLocalhost()) {
        //     headers.uuid = '727181877@qq.com';
        // }
        const res = await fetch(url, {
            method: 'GET',
            headers: headers,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async getAITaskList(eventType, options = {}) {
        const { page = 1, pageSize = 20, sortType = 'desc', search = '', is_completed = 1 } = options;
        const url =
            BASE_URL +
            `/v1/ai/get-all-task-list?type=${encodeURIComponent(eventType)}&offset=${encodeURIComponent(
                (page - 1) * pageSize + 1,
            )}&limit=${encodeURIComponent(pageSize)}&sort=${encodeURIComponent(sortType)}&is_completed=${is_completed}&search=${search}
            `;

        let headers = {};

        if (FJUtil.isLocalhost()) {
            headers.uuid = '727181877@qq.com';
        }

        const res = await fetch(url, {
            method: 'GET',
            headers: headers,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async getUserInfo(userKey = '') {
        const url = `/v1/community/get-user-info`;
        const formData = new FormData();
        formData.append('user_key', userKey);
        return await _fetch(url, formData, 'POST');
    },
    async getShareList(options = {}) {
        const { start = 1, limit = 20, userKey = '' } = options;
        const url = `/v1/community/get-share-list`;
        const formData = new FormData();
        formData.append('start', start);
        formData.append('limit', limit);
        formData.append('user_key', userKey);
        formData.append('current_user', FJCommunityUtil.getUserKey());
        return await _fetch(url, formData, 'POST');
    },
    async getLikeList(options = {}) {
        const { start = 1, limit = 20, userKey = '' } = options;
        const url = `/v1/community/get-like-list`;
        const formData = new FormData();
        formData.append('start', start);
        formData.append('limit', limit);
        formData.append('user_key', userKey);
        return await _fetch(url, formData, 'POST');
    },
    async likeWork(options = {}) {
        const { id = '', like = true } = options;
        const url = `/v1/community/like-work`;
        const formData = new FormData();
        formData.append('result_id', id);
        formData.append('like', like ? 'up' : 'down');
        return await _fetch(url, formData, 'POST', true);
    },

    async publishCommunityWork(options = {}) {
        // public 社区, only_public 默认 , private 私密 down 被举报
        const { ids = '', status = '' } = options;
        const url = `/v1/community/publish`;
        const formData = new FormData();
        formData.append('result_ids', ids.join());
        formData.append('status', status);
        return await _fetch(url, formData, 'POST', true);
    },

    async report(options = {}) {
        const { type, content, key, uid, targetType } = options;
        const url = `/cloudshare/report`;
        const formData = new FormData();
        formData.append('uid', uid);
        formData.append('key', key);
        formData.append('target_type', targetType);
        formData.append('type', type);
        formData.append('content', content);
        return await _fetch(url, formData, 'POST', true);
    },
    async addCommunityBehavior(options = {}) {
        const { communityIds, behaviorType } = options;
        const url = `/v1/community/add-behavior`;
        const formData = new FormData();
        formData.append('community_id', communityIds.join(','));
        formData.append('behavior_type', behaviorType);
        return await _fetch(url, formData, 'POST', true);
    },
    async getAdvertisement() {
        const url = BASE_URL + `/v1/community/get-advertisement`;
        const res = await fetch(url, {
            method: 'GET',
        });
        const { data, code } = await res.json();
        if (code === 200) {
            return data;
        }
        return null;
    },
};
